import { AppConfigModel } from "../abstract/app-config.model";

export class InvoiceOrigin extends AppConfigModel {

    static override CLASS_NAME: string = 'InvoiceOrigin';
}
